import * as React from 'react'
import { Col, Layout, Row, Skeleton, Statistic } from 'antd'
const { Footer, Content } = Layout
import { Navigate } from 'react-router'
import { usePermissions } from 'react-admin'

import { AppLoadingView } from 'dash/AppLoadingView'

// import VersionTimeline from '../version_timeline';

const AdminDashboard: React.FC = () => {
  const { isLoading: permissionsLoading, permissions } = usePermissions()
  if (permissionsLoading) return AppLoadingView
  if (!permissions.includes('admin')) return <Navigate to="/" />

  return (
    <div style={{ margin: 20 }}>
      <Layout title="Admin Dashboard">
        <Content style={{ padding: '10px 20px', background: '#fff' }}>
          <Row>
            <Col>
              <h1>PowCloud Admin</h1>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={6}>
              <h3>KPIs</h3>
              <Row>
                <Col span={12}>
                  <Statistic title="MRR" prefix="$" value={0} />
                </Col>
                <Col span={12}>
                  <Statistic title="Customers" value={0} />
                </Col>
              </Row>

              <table className={'table-attributes'}>
                <tbody>
                  <tr>
                    <td>Gross Revenue</td>
                    <td>$0</td>
                  </tr>
                  <tr>
                    <td>MRR</td>
                    <td>$0</td>
                  </tr>
                  <tr>
                    <td>Paid Accounts</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>Locations</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>Published Documents</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>Admin Users</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
              <Skeleton />
            </Col>
            <Col span={6}>
              <h3>Charts</h3>
              <Skeleton />
              <h3>Signup Flow</h3>
              <table className={'table-attributes'}>
                <tbody>
                  <tr>
                    <td>Signup Engagements</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>Paid Accounts</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col span={6}>
              <h3>Alerts</h3>
              <Skeleton />
            </Col>
            <Col span={6}>
              <h3>Recent Changes</h3>
              {/* <VersionTimeline limit={5} /> */}
            </Col>
          </Row>
        </Content>
        <Footer>
          <small>Copyright PowCloud 2020</small>
        </Footer>
        {/* </Layout> */}
      </Layout>
    </div>
  )
}

export default AdminDashboard
